import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';
import { createCollection } from '../functions/createCollection';

export default function MyGallery({ photos }) {
    const images = photos.map(photo => createCollection(photo));
    return <ImageGallery items={images} />;
}
